<section [formGroup]="card">
  <section class="col-md-12">
    <mat-form-field
      appearance="fill"
      class="col-md-3"
      [class.mat-form-field-invalid]="hasError"
    >
      <mat-label>Required Cards</mat-label>
      <mat-select multiple formControlName="requiredCards">
        <mat-option *ngFor="let cardType of getCardTypes()" [value]="cardType">
          {{ cardType }}
        </mat-option>
      </mat-select>
      <mat-hint class="mat-error" *ngIf="hasError"
        >Organisation is missing some required cards.</mat-hint
      >
    </mat-form-field>

    <mat-form-field appearance="fill" class="col-md-3">
      <mat-label>Required Subtypes</mat-label>
      <mat-select multiple formControlName="requiredSubTypes">
        <mat-option
          *ngFor="let availableSubType of card.controls.availableSubTypes.value"
          [value]="availableSubType"
        >
          {{ availableSubType }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </section>
</section>
